export function dataInRequest(params = {}) {
  return {
    type: '@mensagensTCAGeral/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@mensagensTCAGeral/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@mensagensTCAGeral/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@mensagensTCAGeral/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@mensagensTCAGeral/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@mensagensTCAGeral/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@mensagensTCAGeral/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@mensagensTCAGeral/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@mensagensTCAGeral/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@mensagensTCAGeral/RECORD_FILTERING',
    payload: { params },
  };
}
